<template>

  <!-- <section class="lp_top_image">
      <img src="@/assets/img/tmf2026/tmf2026_album.jpg" />
  </section> -->
  <h1 class="text-center">フォトアルバム</h1>
  <section class="column_content mt-5">

    <!-- トグル見出し -->
    <h3 class="album_toggle mb-3" v-on:click="openInfo('1')" :class="{'is-active': isActive[1]}">ホワイエ
    </h3>
    <!-- トグルで開閉するアルバム -->
    <div v-show="isActive[1]" class="album_content">
      <div class="album_wrap">
        <img src="@/assets/img/tmf2026/album/album01_01.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album01_02.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album01_03.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album01_04.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album01_05.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album01_06.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album01_07.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album01_08.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album01_09.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album01_10.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album01_11.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album01_12.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album01_13.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album01_14.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album01_15.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album01_16.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album01_17.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album01_18.jpg" class="js-album-item">
      </div>
    </div>
    
    <!-- トグル見出し -->
    <h3 class="album_toggle mt-5 mb-3" v-on:click="openInfo('2')" :class="{'is-active': isActive[2]}">会場の様子
    </h3>
    <!-- トグルで開閉するアルバム -->
    <div v-show="isActive[2]" class="album_content">
      <div class="album_wrap">
        <img src="@/assets/img/tmf2026/album/album02_01.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album02_02.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album02_03.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album02_04.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album02_05.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album02_06.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album02_07.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album02_08.jpg" class="js-album-item">
      </div>
    </div>
    
    <!-- トグル見出し -->
    <h3 class="album_toggle mt-5 mb-3" v-on:click="openInfo('3')" :class="{'is-active': isActive[3]}">開始前の風景
    </h3>
    <!-- トグルで開閉するアルバム -->
    <div v-show="isActive[3]" class="album_content">
      <div class="album_wrap">
        <img src="@/assets/img/tmf2026/album/album03_01.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album03_02.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album03_03.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album03_04.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album03_05.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album03_06.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album03_07.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album03_08.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album03_09.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album03_10.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album03_11.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album03_12.jpg" class="js-album-item">
      </div>
    </div>
    
    <h2 class="mt-5 mb-3">第一部</h2>
    <!-- トグル見出し -->
    <h3 class="album_toggle mt-5 mb-3" v-on:click="openInfo('4')" :class="{'is-active': isActive[4]}">兼子社長挨拶
    </h3>
    <!-- トグルで開閉するアルバム -->
    <div v-show="isActive[4]" class="album_content">
      <div class="album_wrap">
        <img src="@/assets/img/tmf2026/album/album04_01.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album04_02.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album04_03.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album04_04.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album04_05.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album04_06.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album04_07.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album04_08.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album04_09.jpg" class="js-album-item">
      </div>
    </div>
    <!-- トグル見出し -->
    <h3 class="album_toggle mt-5 mb-3" v-on:click="openInfo('5')" :class="{'is-active': isActive[5]}">新ビーナスマネージャー
    </h3>
    <!-- トグルで開閉するアルバム -->
    <div v-show="isActive[5]" class="album_content">
      <div class="album_wrap">
        <img src="@/assets/img/tmf2026/album/album05_01.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album05_02.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album05_03.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album05_04.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album05_05.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album05_06.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album05_07.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album05_08.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album05_09.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album05_10.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album05_11.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album05_12.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album05_13.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album05_14.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album05_15.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album05_16.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album05_17.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album05_18.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album05_19.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album05_20.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album05_21.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album05_22.jpg" class="js-album-item">
      </div>
    </div>
    <!-- トグル見出し -->
    <h3 class="album_toggle mt-5 mb-3" v-on:click="openInfo('6')" :class="{'is-active': isActive[6]}">プラネット・ビーナス
    </h3>
    <!-- トグルで開閉するアルバム -->
    <div v-show="isActive[6]" class="album_content">
      <div class="album_wrap">
        <img src="@/assets/img/tmf2026/album/album06_01.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album06_02.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album06_03.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album06_04.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album06_05.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album06_06.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album06_07.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album06_08.jpg" class="js-album-item">
      </div>
    </div>
    <!-- トグル見出し -->
    <h3 class="album_toggle mt-5 mb-3" v-on:click="openInfo('7')" :class="{'is-active': isActive[7]}">三ツ星キャンペーン表彰
    </h3>
    <!-- トグルで開閉するアルバム -->
    <div v-show="isActive[7]" class="album_content">
      <div class="album_wrap">
        <img src="@/assets/img/tmf2026/album/album07_01.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_02.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_03.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_04.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_05.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_06.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_07.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_08.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_09.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_10.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_11.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_12.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_13.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_14.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_15.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_16.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_17.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_18.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_19.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_20.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_21.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_22.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_23.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_24.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_25.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_26.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_27.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_28.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_29.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_30.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_31.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_32.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_33.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_34.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_35.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_36.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_37.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album07_38.jpg" class="js-album-item">
      </div>
    </div>
    <!-- トグル見出し -->
    <h3 class="album_toggle mt-5 mb-3" v-on:click="openInfo('8')" :class="{'is-active': isActive[8]}">プラスワンキャンペーン表彰
    </h3>
    <!-- トグルで開閉するアルバム -->
    <div v-show="isActive[8]" class="album_content">
      <div class="album_wrap">
        <img src="@/assets/img/tmf2026/album/album08_01.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album08_02.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album08_03.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album08_04.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album08_05.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album08_06.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album08_07.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album08_08.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album08_09.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album08_10.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album08_11.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album08_12.jpg" class="js-album-item">
      </div>
    </div>
    <!-- トグル見出し -->
    <h3 class="album_toggle mt-5 mb-3" v-on:click="openInfo('9')" :class="{'is-active': isActive[9]}">バースデーキャンペーン表彰
    </h3>
    <!-- トグルで開閉するアルバム -->
    <div v-show="isActive[9]" class="album_content">
      <div class="album_wrap">
        <img src="@/assets/img/tmf2026/album/album09_01.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album09_02.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album09_03.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album09_04.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album09_05.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album09_06.jpg" class="js-album-item">
      </div>
    </div>
    <!-- トグル見出し -->
    <h3 class="album_toggle mt-5 mb-3" v-on:click="openInfo('10')" :class="{'is-active': isActive[10]}">一般財団法人マナビス会推薦権利保持者紹介
    </h3>
    <!-- トグルで開閉するアルバム -->
    <div v-show="isActive[10]" class="album_content">
      <div class="album_wrap">
        <img src="@/assets/img/tmf2026/album/album10_01.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album10_02.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album10_03.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album10_04.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album10_05.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album10_06.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album10_07.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album10_08.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album10_09.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album10_10.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album10_11.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album10_12.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album10_13.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album10_14.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album10_15.jpg" class="js-album-item">
      </div>
    </div>
    <!-- トグル見出し -->
    <h3 class="album_toggle mt-5 mb-3" v-on:click="openInfo('11')" :class="{'is-active': isActive[11]}">永年継続マネージャー紹介
    </h3>
    <!-- トグルで開閉するアルバム -->
    <div v-show="isActive[11]" class="album_content">
      <div class="album_wrap">
        <img src="@/assets/img/tmf2026/album/album11_01.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album11_02.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album11_03.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album11_04.jpg" class="js-album-item">
      </div>
    </div>
    <!-- トグル見出し -->
    <h3 class="album_toggle mt-5 mb-3" v-on:click="openInfo('12')" :class="{'is-active': isActive[12]}">スキンドレス&UVジェル紹介
    </h3>
    <!-- トグルで開閉するアルバム -->
    <div v-show="isActive[12]" class="album_content">
      <div class="album_wrap">
        <img src="@/assets/img/tmf2026/album/album12_01.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album12_02.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album12_03.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album12_04.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album12_05.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album12_06.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album12_07.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album12_08.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album12_09.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album12_10.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album12_11.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album12_12.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album12_13.jpg" class="js-album-item">
      </div>
    </div>
    <!-- トグル見出し -->
    <h3 class="album_toggle mt-5 mb-3" v-on:click="openInfo('13')" :class="{'is-active': isActive[13]}">シートエクステ新色紹介
    </h3>
    <!-- トグルで開閉するアルバム -->
    <div v-show="isActive[13]" class="album_content">
      <div class="album_wrap">
        <img src="@/assets/img/tmf2026/album/album13_01.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album13_02.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album13_03.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album13_04.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album13_05.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album13_06.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album13_07.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album13_08.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album13_09.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album13_10.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album13_11.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album13_12.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album13_13.jpg" class="js-album-item">
      </div>
    </div>
    <!-- トグル見出し -->
    <h3 class="album_toggle mt-5 mb-3" v-on:click="openInfo('14')" :class="{'is-active': isActive[14]}">社長賞表彰
    </h3>
    <!-- トグルで開閉するアルバム -->
    <div v-show="isActive[14]" class="album_content">
      <div class="album_wrap">
        <img src="@/assets/img/tmf2026/album/album14_01.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_02.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_03.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_04.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_05.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_06.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_07.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_08.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_09.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_10.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_11.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_12.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_13.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_14.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_15.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_16.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_17.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_18.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_19.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_20.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_21.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_22.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_23.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_24.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_25.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_26.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_27.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_28.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_29.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_30.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_31.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_32.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_33.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_34.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_35.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_36.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_37.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_38.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_39.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_40.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_41.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album14_42.jpg" class="js-album-item">
      </div>
    </div>
    
    <h2 class="mt-5 mb-3">第二部</h2>
    <!-- トグル見出し -->
    <h3 class="album_toggle mt-5 mb-3" v-on:click="openInfo('15')" :class="{'is-active': isActive[15]}">開始前ウェルカムドリンク
    </h3>
    <!-- トグルで開閉するアルバム -->
    <div v-show="isActive[15]" class="album_content">
      <div class="album_wrap">
        <img src="@/assets/img/tmf2026/album/album15_01.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album15_02.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album15_03.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album15_04.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album15_05.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album15_06.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album15_07.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album15_08.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album15_09.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album15_10.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album15_11.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album15_12.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album15_13.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album15_14.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album15_15.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album15_16.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album15_17.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album15_18.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album15_19.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album15_20.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album15_21.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album15_22.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album15_23.jpg" class="js-album-item">
      </div>
    </div>
    <!-- トグル見出し -->
    <h3 class="album_toggle mt-5 mb-3" v-on:click="openInfo('16')" :class="{'is-active': isActive[16]}">乾杯
    </h3>
    <!-- トグルで開閉するアルバム -->
    <div v-show="isActive[16]" class="album_content">
      <div class="album_wrap">
        <img src="@/assets/img/tmf2026/album/album16_01.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album16_02.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album16_03.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album16_04.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album16_05.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album16_06.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album16_07.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album16_08.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album16_09.jpg" class="js-album-item">
      </div>
    </div>
    <!-- トグル見出し -->
    <h3 class="album_toggle mt-5 mb-3" v-on:click="openInfo('17')" :class="{'is-active': isActive[17]}">社員紹介
    </h3>
    <!-- トグルで開閉するアルバム -->
    <div v-show="isActive[17]" class="album_content">
      <div class="album_wrap">
        <img src="@/assets/img/tmf2026/album/album17_01.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album17_02.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album17_03.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album17_04.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album17_05.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album17_06.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album17_07.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album17_08.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album17_09.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album17_10.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album17_11.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album17_12.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album17_13.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album17_14.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album17_15.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album17_16.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album17_17.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album17_18.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album17_19.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album17_20.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album17_21.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album17_22.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album17_23.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album17_24.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album17_25.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album17_26.jpg" class="js-album-item">
      </div>
    </div>
    <!-- トグル見出し -->
    <h3 class="album_toggle mt-5 mb-3" v-on:click="openInfo('18')" :class="{'is-active': isActive[18]}">テーブルマジック
    </h3>
    <!-- トグルで開閉するアルバム -->
    <div v-show="isActive[18]" class="album_content">
      <div class="album_wrap">
        <img src="@/assets/img/tmf2026/album/album18_01.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_02.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_03.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_04.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_05.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_06.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_07.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_08.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_09.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_10.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_11.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_12.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_13.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_14.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_15.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_16.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_17.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_18.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_19.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_20.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_21.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_22.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_23.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_24.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_25.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_26.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_27.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_28.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_29.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_30.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_31.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_32.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_33.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_34.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_35.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_36.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_37.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_38.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_39.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_40.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_41.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_42.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_43.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_44.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_45.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_46.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_47.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_48.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_49.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_50.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_51.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_52.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_53.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_54.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_55.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_56.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_57.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_58.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album18_59.jpg" class="js-album-item">
      </div>
    </div>
    <!-- トグル見出し -->
    <h3 class="album_toggle mt-5 mb-3" v-on:click="openInfo('19')" :class="{'is-active': isActive[19]}">新商品パフォーマンス
    </h3>
    <!-- トグルで開閉するアルバム -->
    <div v-show="isActive[19]" class="album_content">
      <div class="album_wrap">
        <img src="@/assets/img/tmf2026/album/album19_01.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album19_02.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album19_03.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album19_04.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album19_05.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album19_06.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album19_07.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album19_08.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album19_09.jpg" class="js-album-item">
      </div>
    </div>
    <!-- トグル見出し -->
    <h3 class="album_toggle mt-5 mb-3" v-on:click="openInfo('20')" :class="{'is-active': isActive[20]}">サンクストリップ発表
    </h3>
    <!-- トグルで開閉するアルバム -->
    <div v-show="isActive[20]" class="album_content">
      <div class="album_wrap">
        <img src="@/assets/img/tmf2026/album/album20_01.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album20_02.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album20_03.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album20_04.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album20_05.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album20_06.jpg" class="js-album-item">
      </div>
    </div>
    <!-- トグル見出し -->
    <h3 class="album_toggle mt-5 mb-3" v-on:click="openInfo('21')" :class="{'is-active': isActive[21]}">テツandトモパフォーマンス
    </h3>
    <!-- トグルで開閉するアルバム -->
    <div v-show="isActive[21]" class="album_content">
      <div class="album_wrap">
        <img src="@/assets/img/tmf2026/album/album21_01.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_02.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_03.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_04.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_05.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_06.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_07.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_08.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_09.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_10.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_11.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_12.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_13.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_14.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_15.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_16.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_17.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_18.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_19.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_20.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_21.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_22.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_23.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_24.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_25.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_26.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_27.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_28.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_29.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_30.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_31.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_32.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_33.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_34.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_35.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_36.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_37.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album21_38.jpg" class="js-album-item">
      </div>
    </div>
    <!-- トグル見出し -->
    <h3 class="album_toggle mt-5 mb-3" v-on:click="openInfo('22')" :class="{'is-active': isActive[22]}">兼子社長中締めご挨拶
    </h3>
    <!-- トグルで開閉するアルバム -->
    <div v-show="isActive[22]" class="album_content">
      <div class="album_wrap">
        <img src="@/assets/img/tmf2026/album/album22_01.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album22_02.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album22_03.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album22_04.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album22_05.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album22_06.jpg" class="js-album-item">
      </div>
    </div>
    <!-- トグル見出し -->
    <h3 class="album_toggle mt-5 mb-3" v-on:click="openInfo('23')" :class="{'is-active': isActive[23]}">閉会お見送り風景
    </h3>
    <!-- トグルで開閉するアルバム -->
    <div v-show="isActive[23]" class="album_content">
      <div class="album_wrap">
        <img src="@/assets/img/tmf2026/album/album23_01.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album23_02.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album23_03.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album23_04.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album23_05.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album23_06.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album23_07.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album23_08.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album23_09.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album23_10.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album23_11.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album23_12.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album23_13.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album23_14.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album23_15.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album23_16.jpg" class="js-album-item">
        <img src="@/assets/img/tmf2026/album/album23_17.jpg" class="js-album-item">
      </div>
    </div>

  </section>

  <div class="box-p-20 text-center mt-5">
    <router-link to="/lp/tmf2026" class="btn d-inline-block">THE MANAVIS FESTIVAL 2026<br>トップに戻る</router-link>
  </div>

  <!-- トップに戻るボタン -->
  <button
    id="page-top"
    class="btn"
    v-on:click="scrollTop"
  >
    TOP
  </button>

  <!-- 画像拡大用 -->
  <div id="modal_overlay">
    <span class="close_btn">&times;</span>
    <img id="modal_img" alt="">
  </div>

</template>

<style scoped>
.album_wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  margin-bottom: 50px;
}

.album_wrap img {
  width: 32%;
  aspect-ratio: 4 / 3;
  object-fit: cover;
  object-position: center;
  cursor: pointer;
}

.column_content h2,
.column_content h3 {
  font-weight: 500 !important;
}

/* トグル見出し */
.album_toggle {
  position: relative;
  margin-bottom: 0 !important;
  padding: 18px 55px 18px 20px;
  background-color: #eeeeee;
  cursor: pointer;
  box-sizing: border-box;
}

/* 横線 */
.album_toggle::before {
  content: "";
  position: absolute;
  top: 50%;
  right: 20px;
  width: 18px;
  height: 2px;
  background-color: #333333;
  transform: translateY(-50%);
}

/* 縦線 */
.album_toggle::after {
  content: "";
  position: absolute;
  top: 50%;
  right: 28px;
  width: 2px;
  height: 18px;
  background-color: #333333;
  transform: translateY(-50%);
  transition: opacity 0.2s;
}

/* 開いているときはマイナス表示 */
.album_toggle.is-active::after {
  opacity: 0;
}

/* トグル内部 */
.album_content {
  padding-top: 20px;
}

small {
  font-size: 0.7em;
}

button#page-top {
  position: fixed;
  left: 20px;
  bottom: 20px;
  z-index: 100;
}

/* 拡大表示時の背景 */
#modal_overlay {
  display: none;
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  align-items: center;
  justify-content: center;
  cursor: zoom-out;
}

/* 拡大画像本体 */
#modal_img {
  max-width: 90%;
  max-height: 90%;
  object-fit: contain;
  animation: zoomIn 0.3s;
}

/* 閉じるボタン */
.close_btn {
  position: absolute;
  top: 20px;
  right: 30px;
  color: #ffffff;
  font-size: 40px;
  cursor: pointer;
}

@keyframes zoomIn {
  from {
    transform: scale(0.8);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
}

@media screen and (max-width: 768px) {
  .album_wrap img {
    width: 100%;
  }

  .album_toggle {
    padding: 15px 50px 15px 15px;
  }
}
</style>

<script>
import $ from "jquery";

$(function() {
  const topBtn = $("#page-top");

  topBtn.hide();

  // スクロールが500pxに達したらボタンを表示
  $(window).scroll(function() {
    if ($(this).scrollTop() > 500) {
      topBtn.fadeIn();
    } else {
      topBtn.fadeOut();
    }
  });
});

export default {
  data: () => {
    return {
      isActive: []
    };
  },

  mounted() {
    window.scroll(0, 0);

    /*
     * false：最初は閉じた状態
     * true：最初から開いた状態
     */
    for (let i = 0; i < 2; i++) {
      this.isActive[i] = false;
    }

    const items = document.querySelectorAll(".js-album-item");
    const overlay = document.getElementById("modal_overlay");
    const modalImg = document.getElementById("modal_img");
    const closeBtn = document.querySelector(".close_btn");

    // 画像クリック時の処理
    items.forEach(item => {
      item.addEventListener("click", () => {
        modalImg.src = item.src;
        overlay.style.display = "flex";
        document.body.style.overflow = "hidden";
      });
    });

    // オーバーレイまたは閉じるボタンをクリック
    [overlay, closeBtn].forEach(el => {
      el.addEventListener("click", () => {
        overlay.style.display = "none";
        document.body.style.overflow = "";
      });
    });
  },

  methods: {
    // トグル開閉
    openInfo(ref) {
      this.isActive[ref] = !this.isActive[ref];
    },

    // ページ上部へ戻る
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }
};
</script>